var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed left-0 bottom-0 w-full text-center mb-4 text-xs invisible lg:visible "},[_c('p',[_vm._v("Made with 💚 in Munich")])])}]

export { render, staticRenderFns }